import { createSlice } from "@reduxjs/toolkit";
const EMPTY_ARRAY = []; // Stable reference

// Holds the authz.* resolution from GET /api/Authorization/access-data/{companyId}:
// roles, permissions and menu for the caller in one company. Workflows are fetched on demand
// by the workflow pages instead - see workflowAccessSlice / useWorkflowAccess.
const accessDataSlice = createSlice({
	name: "accessData",
	initialState: {
		data: null, // Full ApiResponse<AccessDataResponseDTO>
		loading: false,
		error: null,
	},
	reducers: {
		fetchAccessDataRequest: (state) => {
			state.loading = true;
			state.error = null;
		},
		fetchAccessDataSuccess: (state, action) => {
			state.loading = false;
			state.data = action.payload;
		},
		fetchAccessDataFailure: (state, action) => {
			state.loading = false;
			state.error = action.payload;
		},
	},
});

// Selectors - response is ApiResponse<AccessDataResponseDTO>, payload under .data
export const selectAccessDataRoles = (state) => state.accessData.data?.data?.roles || EMPTY_ARRAY;
export const selectAccessDataPermissions = (state) => state.accessData.data?.data?.permissions || EMPTY_ARRAY;
export const selectAccessDataMenu = (state) => state.accessData.data?.data?.menu || EMPTY_ARRAY;

export const { fetchAccessDataRequest, fetchAccessDataSuccess, fetchAccessDataFailure } = accessDataSlice.actions;

export default accessDataSlice.reducer;
